import React from "react";
import mainImg from "../../assets/images/jjj.jpeg";
import { Link } from "react-router-dom";

const AboutSection = () => {
  return (
    <section className="about-sectiona">
      <div className="about-containera">
        <div className="about-imagesa">
          <div className="main-imga">
            <img src={mainImg} alt="Ayurveda Treatment" />
            <div className="experience-badgea">
              <span>Pachan Care Powder</span>
            </div>
          </div>
        </div>
        <div className="about-contenta">
          <span className="subtitlea">Pachan Care Powder</span>
          <h2>A Natural Ayurvedic Approach to Better Digestion & Wellness</h2>
          <p>
            Pachan Care Powder is a natural Ayurvedic digestive formula designed
            to support healthy digestion and improve gut balance. Made with
            carefully selected herbs and traditional Ayurvedic ingredients, it
            helps relieve common digestive issues such as acidity, gas,
            bloating, and indigestion. Regular use supports better nutrient
            absorption and overall digestive wellness, promoting a lighter and
            healthier feeling throughout the day.
          </p>
          <ul className="pachan-key">
            <li>Improves Digestion Naturally</li>
            <li>100% Ayurvedic & Herbal Formula</li>
            <li>Supports Gut Balance & Daily Wellness</li>
          </ul>
          <Link to="/about" className="about-btn-link">
            <button className="about-btna">More About Us</button>
          </Link>{" "}
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
